// 📂 src/services/client/ClientProfileSwitchService.ts
import { clientProfileApi } from "../../api";

/**
 * 📌 Servicio para gestión del perfil activo del cliente.
 */
const ClientProfileSwitchService = {
  /**
   * 📥 Obtiene el perfil actualmente activo.
   * GET /api/client-profiles/active
   */
  getActiveProfile: async () => {
    const response = await clientProfileApi.fetchCustom("/active");
    return response.data;
  },

  /**
   * 🔄 Cambia el perfil activo del cliente.
   * POST /api/client-profiles/switch/{profileId}
   */
  switchProfile: async (profileId: number) => {
    const response = await clientProfileApi.addCustom(`/switch/${profileId}`, {});
    return response.data;
  },
};

export default ClientProfileSwitchService;
